import { ExportActionsEnum } from '../enums/ExportActionsEnum';
import { IExportState } from '../interfaces/IExportState';
import { ExportAction } from '../types/ExportAction';

const initial: IExportState = {
  data: [],
  order: null,
  page: 0,
  pageCount: 0,
  totalCount: 0,
};

export function exportReducer(state = initial, action: ExportAction) {
  switch (action.type) {
    case ExportActionsEnum.EXPORT_SET_DATA: {
      const { data, page, totalCount, pageCount } = action.payload;
      const newState: IExportState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case ExportActionsEnum.EXPORT_SET_ORDER: {
      const { order } = action.payload;
      const newState: IExportState = {
        ...state,
        order,
      };

      return newState;
    }
    default:
      return state;
  }
}
